import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseRestService } from "./base-rest.service";

@Injectable({
    providedIn: 'root'
})
export class PrintingFormsService extends BaseRestService {

    readonly API_URL: string = environment.printingUri + '/printing/forms/';

    getList(pageParams: any): Observable<any> {
        const options = {
            headers: this.headers,
            params: this.removeEmptyPropertyFromObject(pageParams)
        }
        return this.httpClient.get(this.API_URL, options);
    }

    getById(id: string): Observable<any> {
        return this.httpClient.get(this.API_URL + id,
            { headers: this.headers });
    }

    create(data): Observable<any> {
        let headers = new HttpHeaders();
        headers.append("Content-Type", " multipart/form-data");
        return this.httpClient.post(this.API_URL, data,
            { headers: headers, responseType: 'text' });
    }

    update(id, data): Observable<any> {
        let headers = new HttpHeaders();
        headers.append("Content-Type", " multipart/form-data");
        return this.httpClient.put(this.API_URL + id, data,
            { headers: headers, responseType: 'text' });
    }

    delete(id: string): Observable<any> {
        return this.httpClient.delete(this.API_URL + id,
            { headers: this.headers, responseType: 'text' });
    }

    changeStatus(id: string, data): Observable<any> {
        return this.httpClient.patch(this.API_URL + id + "/status", data,
            { headers: this.headers,  responseType: 'text' });
    }

    generatePrintingForm(id, data): Observable<any> {
        let headers = new HttpHeaders();
        headers.append("Content-Type", "application/octet-stream")
        return this.httpClient.post(this.API_URL + id + "/generate", null,
            { headers: headers, params: data, responseType: "blob" as 'blob' });
    }

    download(id: string): Observable<any> {
        let headers = new HttpHeaders();
        headers.append("Content-Type", "application/octet-stream")
        return this.httpClient.get(this.API_URL + id + "/download",
            { headers: headers, responseType: "blob" as 'blob' });
    }

}
